import { render, staticRenderFns } from "./TaxLossDetails.vue?vue&type=template&id=36a8589c"
import script from "./TaxLossDetails.vue?vue&type=script&lang=js"
export * from "./TaxLossDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a8589c')) {
      api.createRecord('36a8589c', component.options)
    } else {
      api.reload('36a8589c', component.options)
    }
    module.hot.accept("./TaxLossDetails.vue?vue&type=template&id=36a8589c", function () {
      api.rerender('36a8589c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/tax_return/TaxLossDetails.vue"
export default component.exports